export function getFileName(name) {
    return name.substr(0, name.lastIndexOf('.'));
}
//# sourceMappingURL=getFileName.js.map